import ENUMPlatform from "./ENUMPlatform";

/**
 * 管理静态数据
 */
const state = {
  PublishPlatformTabs: {
    0: {
      label: "All",
      key: 0,
      value: 0,
      icon: ""
    },
    1: {
      label: "Facebook",
      key: 1,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Facebook.webp"
    },
    // 2: { label: "X", key: 2, value: 0, icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/X.webp" },
    4: {
      label: "Instagram",
      key: 4,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Instagram.webp"
    },
    5: {
      label: "TikTok",
      key: 5,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/TIKTOK.webp"
    },
    6: {
      label: "YouTube",
      key: 6,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/youtube.webp"
    },
    8: {
      label: "Telegram",
      key: 8,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/telegram.webp"
    },
    7: {
      label: "Linkedin",
      key: 7,
      value: 0,
      icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/linkedin.webp"
    }

    // 9: { label: "VK", key: 9, value: 0, icon: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/VK.webp" },
  },
  d_tmpls: [{
    type: 3,
    id: 3,
    name: "营销策略",
    desc: "为您需要的某个产品生成一段营销方案"
  }, {
    type: 2,
    id: 2,
    name: "写帖文",
    desc: "写一篇Facebook/Twitter的帖文POST"
  }, {
    type: 4,
    id: 4,
    name: "广告词",
    desc: "为您需要的某个产品/品牌生成一段广告词"
  }],
  cs_platforms: {
    1: "Facebook",
    2: "Instagram",
    3: "WhatsApp",
    4: "独立站"
  },
  logistics_status_name: {
    1: "已发货订单处理",
    2: "未发货订单",
    3: "交易单号不存在",
    4: "未提供交易单号"
  },
  csPlatformIcons: {
    1: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Messenger.webp",
      alt: "Messenger"
    },
    2: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Instagram.webp",
      alt: "Instagram"
    },
    facebook: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Facebook.webp",
      alt: "Facebook"
    }
  },
  yuqing_platform_icons: {
    // 成员社交账号接口以数字 3 标识 WhatsApp，头像角标和平台筛选共用此图标配置。
    3: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Whatsapp.webp",
      alt: "WhatsApp"
    },
    1: {
      // url: "https://static.xx.fbcdn.net/rsrc.php/yE/r/xotM8R60Dei.svg",
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Facebook.webp",
      alt: "Facebook"
    },
    2: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/X.webp",
      // url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/X-square.webp",
      // url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/twitter-logo.png",
      alt: "X"
    },
    4: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Instagram.webp",
      // url: "https://static.xx.fbcdn.net/rsrc.php/yM/r/gXv36GX8I6t.svg",
      // url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/ins-logo.png",
      alt: "Instagram"
    },
    5: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/TIKTOK.webp",
      // url: "https://sf16-website-login.neutral.ttwstatic.com/obj/tiktok_web_login_static/tiktok/web/tiktok_web_pages/build/_assets/logo-dark-d62c3812fbf2f687daa9.svg",
      alt: "TikTok"
    },
    6: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/youtube.webp",
      // url: "https://joinmc.s3.ap-northeast-1.amazonaws.com/logo/youtube-svgrepo-com.svg",
      alt: "YouTube"
    },
    9: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/VK.webp",
      alt: "VK"
    },
    WhatsApp: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Whatsapp.webp",
      alt: "WhatsApp"
    },
    8: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/telegram.webp",
      alt: "Telegram"
    },
    7: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/linkedin.webp",
      alt: "Linkedin"
    },
    Shop: {
      url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Shop.png",
      alt: "电商平台"
    }
    // url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/linkedin.webp",
    // url: "https://joinmc-help.oss-cn-beijing.aliyuncs.com/logo/Shop.png",
  },
  /** waba 手机号质量等级 */
  waba_phone_quality_rating: {
    GREEN: {
      label: "platform.WA-Quality-GREEN",
      tag_type: "success"
    },
    YELLOW: {
      label: "platform.WA-Quality-YELLOW",
      tag_type: "warning"
    },
    RED: {
      label: "platform.WA-Quality-RED",
      tag_type: "danger"
    },
    UNKNOWN: {
      label: "platform.WA-Quality-UNKNOWN",
      tag_type: "info"
    }
  },
  /**
   * whatsapp 手机号状态
   */
  waba_phone_status: {
    PENDING: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-PENDING"
    },
    UNVERIFIED: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-UNVERIFIED"
    },
    MANUAL_REVIEW: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-MANUAL_REVIEW"
    },
    DISCONNECTED: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-DISCONNECTED"
    },
    CONNECTED: {
      tag_type: "success",
      label: "platform.WA-PhoneStatus-CONNECTED"
    },
    FLAGGED: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-FLAGGED"
    },
    WARNED: {
      tag_type: "warning",
      label: "platform.WA-PhoneStatus-WARNED"
    },
    RATE_LIMITED: {
      tag_type: "warning",
      label: "platform.WA-PhoneStatus-RATE_LIMITED"
    },
    BANNED: {
      tag_type: "danger",
      label: "platform.WA-PhoneStatus-BANNED"
    },
    RESTRICTED: {
      tag_type: "warning",
      label: "platform.WA-PhoneStatus-RESTRICTED"
    },
    BLOCKED: {
      tag_type: "warning",
      label: "platform.WA-PhoneStatus-BLOCKED"
    },
    MIGRATED: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-MIGRATED"
    },
    UNKNOWN: {
      tag_type: "info",
      label: "platform.WA-PhoneStatus-UNKNOWN"
    }
  },
  yuqing_platform_config: ENUMPlatform.platform_config,
  yuqing_task_status: {
    1: "已发布",
    2: "发布失败",
    3: "进行中"
  }
};
const mutations = {};
const actions = {};
const getters = {};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};